import { keepPreviousData, useQuery } from "@tanstack/react-query";

import userViewGuard from "~/hooks/useViewPermssionsCheck";
import { pendingInvoicesQueries } from "~/modules/billing/api/pendingInvoice/pendingInvoiceQueries.ts";
import PendingInvoicesIndexView from "~/modules/billing/components/PendingInvoicesIndexView/PendingInvoicesIndexView";
import { useAllUsers } from "~/modules/user/api/user/userQueries.ts";
import { PermissionNames } from "~/types/entityNames.ts";

const PendingInvoicesIndexPage = () => {
	const guard = userViewGuard([PermissionNames.CanManageInvoices, PermissionNames.CanViewInvoices]);
	if (guard) return guard;


	// prefetch all non-pending invoices and users to ensure they are available when needed
	useAllUsers();

	const { data: allPendingInvoices, isLoading, isFetching } = useQuery({
		...pendingInvoicesQueries.all(), refetchOnMount: "always",
		refetchOnWindowFocus: true,
		placeholderData: keepPreviousData,
	});

	return <PendingInvoicesIndexView isLoading={isLoading}
									 isFetching={isFetching}
									 pendingInvoicesData={allPendingInvoices} />;
};

export default PendingInvoicesIndexPage;